<template>
  <v-container fluid name = "nombre">
    <v-layout
      d-flex
      column
    >
      <v-flex
        md2
        offset-md2
      >
        <v-card
          class="title"
          color="green lighten-5"
        >
          <v-text-field
            v-model="nombre" 
            @keyup="keyup"
            type="text"
            class="form-control"/>
        </v-card>
      </v-flex>
      <v-flex
        md4
        offset-md2>
        <v-card
          class="title"
          color="green lighten-5"
        >
          <NombreEnChiffres v-if="enChiffres && parsedNumber!=null" :parsedNumber="parsedNumber" />
          <NombreEnLettres v-if="enLettres && parsedNumber!=null" :parsedNumber="parsedNumber" />
          <NombreEnDessin v-if="enValises && parsedNumber!=null" :parsedNumber="parsedNumber" />
          <NombreEnMetre v-if="enMetres && parsedNumber!=null" :parsedNumber="parsedNumber" />
        </v-card>
      </v-flex>
    </v-layout>
    <table>
      <tr>
        <td rowspan=3 valign=top>
          <font size=-1>
            <p>
              <input type =submit name=valider value="reafficher"></p>
              <p>
                <v-checkbox
                  name="En chiffre"
                  :label="`En chiffres.`"
                  v-model="enChiffres"/>
                <v-checkbox
                  name="En valises"
                  :label="`En valises, boîtes et billes.`"
                  v-model="enValises"/>
                <v-checkbox
                  name="En lettres"
                  :label="`En lettres.`"
                  v-model="enLettres"/>
                <v-checkbox
                  name="En metres"
                  :label="`En mètres.`"
                  v-model="enMetres"/>
            </p>

              <p> Nombre au hasard</p>
              <p> 
                <input type =submit name=hasard value="<100" /> 
                <input type =submit name=hasard value="<1000" /> 
                <input type =submit name=hasard value="<10000" /> 
              </p>
          </font>
        </td>
      </tr>
    </table>
  </v-container>
</template>
<script>
  import NombreEnLettres from '@/components/maths/NombreEnLettres'
  import NombreEnChiffres from '@/components/maths/NombreEnChiffres'
  import NombreEnDessin from '@/components/maths/NombreEnDessin'
  import NombreEnMetre from '@/components/maths/NombreEnMetre'
  import MaskedInput from 'vue-masked-input'

  export default {
    name: "Nombre",

    components: {
      MaskedInput,
      NombreEnChiffres,
      NombreEnLettres,
      NombreEnDessin,
      NombreEnMetre,
    },
    computed: {
    },
    watch: {
      nombre: function (nn, on) {
        Number.isInteger(nn)?this.keyup():false;
      }
    },
    data () {
      return {
        parsedNumber:null,
        nombre:'',
        enChiffres:true,
        enValises:true,
        enMetres:true,
        enLettres:true,
        milliers:0,
        centaines:0,
        dizaines:0,
        unites:0,
      }
    },
    methods: {
      isValid(){
        let n=parseInt(this.nombre);
        return n;
      },
      keyup() {
        if(this.isValid()){
          this.parsedNumber = this.rang(this.nombre);
        }
      },

      /**
       * return (int)nombre into array 
       * @param {type} nombre
       * @returns {u|String}
       */
      rang(nombre) { //dispache les chiffres d'un nombre dans un tableau associatif
          nombre = "    "+nombre;
          nombre = nombre.substr(nombre.length - 4);
          this.nombre=nombre;
          let u = [];
          let rang = ["bille", "boite", "valise", "caisse"];

          for(let i=0;i < nombre.length;i++) {
              u[i] = nombre[i];
          }
          return u;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
